import appActions from 'actions/app';
import apiActions from 'actions/api';
import routerActions from 'actions/router';
import API from 'types/api';
import { PATH } from 'types/router';
import _ from 'lodash';
import { isUserLoggedInSelector } from 'selectors/user';
import { safeLocalStorage } from '../utils/safeLocalStorage';

const LOGOUT_KEY = 'forceLogout';
const LOGIN_KEY = 'forceLogin';
let _store; //eslint-disable-line

export default (store) => (next) => (action) => {
  _store = store;

  if (action.type === API.POST_LOGOUT_SUCCESS) {
    safeLocalStorage.setItem(LOGOUT_KEY, Math.random());
    safeLocalStorage.removeItem(LOGOUT_KEY);
  } else if (
    action.type === API.GET_USER_SUCCESS ||
    action.type === API.POST_AUTH_SUCCESS ||
    (action.type === API.POST_REGISTRATION_SUCCESS &&
      _.get(action.payload, 'status.completion') === 'complete')
  ) {
    safeLocalStorage.setItem(LOGIN_KEY, Math.random());
    safeLocalStorage.removeItem(LOGIN_KEY);
  }
  return next(action);
};

window.addEventListener('storage', (event) => {
  if ((event.key === LOGOUT_KEY || event.key === LOGIN_KEY) && event.newValue && _store) {
    const loggedIn = isUserLoggedInSelector(_store.getState());
    if (event.key === LOGOUT_KEY && loggedIn) {
      _store.dispatch(appActions.forceLogout());
      _store.dispatch(appActions.forceDataUpdate());
      dispatchGoToInfo();
    } else if (event.key === LOGIN_KEY && !loggedIn) {
      _store.dispatch(apiActions.getUser());
      dispatchGoToInfo();
    }
  }

  function dispatchGoToInfo() {
    if (window.location.pathname.indexOf('player') === -1) {
      _store.dispatch(routerActions.goTo(PATH.INFO));
    }
  }
});
